
export const langService = {
    get,
    set
};

import { lStorage, lStorageKeys } from '../helpers/lStorage';

function get(username, password) {
    let lang = lStorage.get(lStorageKeys.APP_LANG);
    return lang ? lang : 'pl'
}

function set(lang) {
    lStorage.set(lStorageKeys.APP_LANG, lang);
}